import { DateUtilsService } from '../services/date-utils.service';
import { TranslateService } from '@ngx-translate/core';
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { blobToBase64 } from '../utils'


export class ClinicContact {
    id: number | null = null;
    userId: number| null = null;
    name: string = '';
    phone: string = '';
    email: string = '';
}